import React from "react";
import PropTypes from "prop-types";
import { withStyles, Snackbar } from "@material-ui/core";
import { connect } from "react-redux";
import { styles } from "./../downloader/DownloadLink.css";
import { Translation } from "react-i18next";
import { Menu, MenuItem, CircularProgress } from "@material-ui/core";
import { FaFileExcel } from "react-icons/fa";
import {
    updateDownloads,
} from "../../redux/actions/DownloadActions";
import Confirm from "../Confirm";
import { activityLimitActions } from "../UserActivityLimit";
import GetAppIcon from "@material-ui/icons/GetApp";
var fileDownload = require('js-file-download');

class DownloadXMLLink extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            anchorEl: null,
            abuseMsg: null,
            abuseFlag: null,
            errorMessage: null,
            isXMLDownloading: false,
        };
    }

    handleClick = (event) => {
        event.stopPropagation();
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => this.setState({ anchorEl: null });

    handleCloseAbuseMsg = () => {
        this.setState({ abuseMsg: null });
        activityLimitActions(this.state.abuseFlag);
    };

    messageTimeout = null;
    showError = (errorMessage) => {
        clearTimeout(this.messageTimeout);
        this.setState({ errorMessage });
        this.messageTimeout = setTimeout(() => {
            this.setState({ errorMessage: null });
        }, 8000);
    };

    componentDidUpdate(prevProps) {
        const { track } = this.props;

        if (track?.id !== prevProps?.track?.id) {
            this.setState({ anchorEl: null });
        }
    }

    handleDownloadXml = (type) => {
        const {
            downloadXML,
            track
        } = this.props

        this.setState({ isXMLDownloading: true });

        var tracksToBeSent = [];

        var trackToBeSent = {
            "trackId": track.id,
            "trackType": type,
            "dhTrackId": track.dhTrackId
        };
        tracksToBeSent.push(trackToBeSent);

        downloadXML("Downloading...","XML", tracksToBeSent, ((data, error) => {  
            if (!data && error) {
                this.setState({ isXMLDownloading: false });
                 this.showError("Error in downloading XML");
            }else{
                var fileName = data.headers?.filename;
                this.setState({ isXMLDownloading: false });
                fileDownload(data.data, decodeURIComponent(fileName));
            }
        }));
    };

    render() {
        const {
            classes,
            isMenuItem,
            id,
            anchorOrigin,
        } = this.props;
        const { anchorEl } = this.state;

        return (
            <Translation>
                {(t, { i18n }) => (
                    <>
                        <Snackbar
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                            open={this.state.errorMessage ? true : false}
                            message={this.state.errorMessage}
                            className={classes.snackbar}
                        />
                        <Confirm
                            name="abuseDialog"
                            classes
                            isOpen={this.state.abuseMsg ? true : false}
                            title="Warning"
                            innerHtmlContent={this.state.abuseMsg}
                            confirm="OK"
                            // cancel=""
                            onConfirm={() => this.handleCloseAbuseMsg()}
                        // onCancel={}
                        />
                        <MenuItem
                            aria-label={'Metadata Downloads'}
                            aria-controls="action"
                            aria-haspopup="true"
                            onClick={this.handleClick}
                            title={'Metadata Downloads'}
                            id={`context-download-metadata-${id}`}
                             
                        >
                            <GetAppIcon className={classes.contextIcons} />{" "}
                            Download Metadata XML&nbsp;&nbsp;&nbsp;{" "}
                            {this.state.isXMLDownloading && (
                                <CircularProgress size={20} className={classes.preLoader} />
                            )}                            
                        </MenuItem>
                        <Menu
                            keepMounted
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                horizontal: isMenuItem
                                    ? anchorOrigin
                                        ? anchorOrigin
                                        : "right"
                                    : "left",
                                vertical: "bottom",
                            }}
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}
                        >

                            <MenuItem
                                onClick={() => {
                                    this.handleClose();
                                    this.handleDownloadXml('Contemporary');
                                }}
                                id={`context-download-contemporary-${id}`}
                               
                            >
                                <FaFileExcel className={classes.iconContext} /> XML - Contemporary
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    this.handleClose();
                                    this.handleDownloadXml('Classical');
                                }}
                                id={`context-download-classical-${id}`}
                                
                            >
                            

                                <FaFileExcel className={classes.iconContext} /> XML - Classical
                            </MenuItem>

                        </Menu>
                    </>
                )}
            </Translation>
        );
    }
}

DownloadXMLLink.propTypes = {
    classes: PropTypes.object.isRequired,
    track: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        setDownloads: (payload) => dispatch(updateDownloads(payload)),
    };
};

const mapStateToProps = (state) => ({
    download: state.download,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DownloadXMLLink));
